<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import Toast from '@/components/ui/Toast.vue'
</script>

<template>
  <AppHeader />
  <RouterView />
  <AppFooter />
  <Toast />
</template>
